import React, { useContext } from 'react';
import AntLocalization from '../../utils/AntLocalization';
import { AntSessionContext } from '../../utils/AntContext';
import FloatingWorkPanel from '../FloatingWorkPanel';
import AntAIAssistant from '../AntAIAssistant';

// Wrapper mỏng — dùng AntAIAssistant (topic-based sessions, file upload, streaming).
function detectModuleFromURL() {
    if (typeof window === 'undefined') return null;
    var path = (window.location.hash || '') + ' ' + (window.location.pathname || '');
    var map = [
        { re: /\/(ar)\//i, mod: 'ar' },
        { re: /\/(ap)\//i, mod: 'ap' },
        { re: /\/(ca)\//i, mod: 'ca' },
        { re: /\/(inv|ic)\//i, mod: 'ic' },
        { re: /\/(gl)\//i, mod: 'gl' },
        { re: /\/(lg)\//i, mod: 'lg' },
        { re: /\/(hrm|hr)\//i, mod: 'hr' },
        { re: /\/(crm)\//i, mod: 'crm' }
    ];
    for (var i = 0; i < map.length; i++) {
        if (map[i].re.test(path)) return map[i].mod;
    }
    return null;
}

export default function AIFloating(props) {
    var visible = props.visible;
    var onClose = props.onClose;
    var session = useContext(AntSessionContext);
    var moduleCode = props.module || detectModuleFromURL();
    if (!visible) return null;

    function handleMaximize(ctx) {
        var qs = ['module', 'sessionCode', 'topicCode']
            .filter(function (k) { return ctx && ctx[k]; })
            .map(function (k) { return k + '=' + encodeURIComponent(ctx[k]); })
            .join('&');
        var url = '/ai/AIWorkspace' + (qs ? '?' + qs : '');
        if (typeof window !== 'undefined') window.location.href = '#' + url;
        if (onClose) onClose();
    }

    return (
        <FloatingWorkPanel
            visible={true}
            onClose={onClose}
            title={AntLocalization.translateText({ vi: 'Trợ lý AI', en: 'AI Assistant', fr: 'Assistant IA', es: 'Asistente IA', id: 'Asisten AI', ja: 'AIアシスタント', zh: 'AI助手', ko: 'AI 어시스턴트', hi: 'AI सहायक', ar: 'مساعد AI' })}
            icon="message"
            className="ai-floating"
            renderDetail={function () {
                return (
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <AntAIAssistant
                            session={session}
                            module={moduleCode}
                            initialTopicCode={props.initialTopicCode}
                            mode="drawer"
                            title={{ vi: 'Trợ lý AI', en: 'AI Assistant', fr: 'Assistant IA', es: 'Asistente IA', id: 'Asisten AI', ja: 'AIアシスタント', zh: 'AI助手', ko: 'AI 어시스턴트', hi: 'AI सहायक', ar: 'مساعد AI' }}
                            showRail={true}
                            onMaximize={handleMaximize}
                            onVoucherCreated={props.onVoucherCreated}
                        />
                    </div>
                );
            }}
        />
    );
}
